// @flow
import { handleResponseOld, makePost } from './helpers';

type PostResellerTypeParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    resellerType: number,
};

export default {
    postResellerType: ({ authToken, bidderId, deployment, resellerType }: PostResellerTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: `reseller/${bidderId}`,
                authToken,
                deployment,
                path: '<USER-API>',
            });
            request.send({ resellerType: resellerType });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
